import { Dispatch, memo, SetStateAction } from 'react'

import { useGetSubjectsQuery } from '@/services/api'
import type { QuestionTag } from '@/types'

import TagAutocomplete from './TagAutocomplete'

interface SubjectAutocompleteProps {
  subjectTags: QuestionTag[]
  setSubjectTags: Dispatch<SetStateAction<QuestionTag[]>>
}

function SubjectAutocomplete({ subjectTags, setSubjectTags }: SubjectAutocompleteProps) {
  const { subjects, isLoading } = useGetSubjectsQuery(undefined, {
    selectFromResult: ({ data = [], isLoading, isFetching }) => {
      const uniqueSubjects = Array.from(
        new Map(data.map((subject) => [subject.name, subject])).values(),
      ).sort((a, b) => a.name.localeCompare(b.name))

      return {
        subjects: uniqueSubjects,
        isLoading: isLoading || isFetching,
      }
    },
  })

  return (
    <TagAutocomplete
      options={subjects}
      loading={isLoading}
      value={subjectTags}
      setValue={setSubjectTags}
      placeholder="Adicionar disciplinas..."
      label="Disciplinas"
    />
  )
}

export default memo(SubjectAutocomplete)
